import { createEffect, sample } from 'effector'
import type { NextRouter } from 'next/router'

import { browserLang } from '@portal/lib/browser-lang'

import { env } from '@/shared/config'
import { appStarted } from '@/shared/lib/app'
import { type Language, langSelected } from '@/shared/lib/i18n'
import { getPreferredLanguage, getRouterLanguage, setPreferredLanguage } from '@/shared/lib/language'
import { $router } from '@/shared/lib/next'
import { isNotNull } from '@/shared/lib/types'

sample({
    clock: appStarted,
    filter: () => !getPreferredLanguage(),
    fn: () => browserLang({ languages: env.LANG_LIST, fallback: env.LANG_FALLBACK }) as Language,
    target: langSelected,
})

sample({
    clock: langSelected,
    target: createEffect(setPreferredLanguage),
})

sample({
    clock: langSelected,
    source: $router,
    filter: isNotNull,
    fn: (router: NextRouter, lang: Language) => ({ router, lang }),
    target: createEffect(updateRouteLanguage),
})

function updateRouteLanguage({ router, lang }: { router: NextRouter; lang: Language }) {
    const routerLanguage = getRouterLanguage(router)

    // update only localized paths
    if (!routerLanguage) {
        return
    }

    // do not update route if desired language is already selected
    if (routerLanguage === lang) {
        return
    }

    const newPath = `/${lang}${router.asPath.slice(3)}`
    void router.push(newPath)
}
